import Navbar from "../components/navbar/Navbar";
import Partilhar from "../components/partilhar/Partilhar";
import Feed from "../components/feed/Feed";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useContext, useRef } from "react";
import { AuthContext } from "../../context/AuthContex";
import { deepPurple } from "@material-ui/core/colors";
import { IconButton, Tooltip } from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { CircularProgress } from "@material-ui/core";
import "./profile.css";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Profile(props) {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PS = process.env.REACT_APP_PUBLIC_SERVER;

  const userId = useParams().userId;

  const { user: currentUser } = useContext(AuthContext);
  const [user, setUser] = useState([]);
  const [newUser, setnewUser] = useState([]);
  const [updUser, setupdUser] = useState([]);
  const [friendList, setFriendList] = useState(false);
  const [followingUser, setFollowinguser] = useState("");
  const [ErroMessage, setErroMessage] = useState(null);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [fileBi, setFileBi] = useState(null);
  const [fileProcurador, setfileProcurador] = useState(null);
  const [diario_republica, setdiario_republica] = useState(null);
  const [registo_comercial, setregisto_comercial] = useState(null);
  const [nif, setnif] = useState(null);
  const [Contrato_Sociedade, setContrato_Sociedade] = useState(null);

  const [check, setCheck] = useState(false);

  const [imgselected, setimgselected] = useState(null);
  const [dialogMessage, setdialogMessage] = useState({
    message: "Guardado Com Successo",
    style: "success",
  });

  const userupdated = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchUser = async () => {
      const res = await axios.get("usuarios?userId=" + currentUser._id);

      if (res.data.seguidores.includes(currentUser._id)) {
        setFriendList(true);
      } else {
        setFriendList(false);
      }

      setUser(res.data);
    };
    fetchUser();
  }, [userId, updUser, followingUser, file]);

  const submitHandler = async () => {
    const imageUpdated = { userId: currentUser._id };

    if (file) {
      const data = new FormData();
      const fileName = Date.now() + file.name;
      data.append("file", file);
      data.append("name", fileName);

      try {
        const res = await axios.post("usuarios/upload-profile", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        imageUpdated.imagemProfil = res.data.img;
      } catch (err) {
        console.log(err);
      }
    }

    try {
      await axios.put("usuarios/" + currentUser._id, imageUpdated);
      setFile(null);
      userupdated.imagemProfil = imageUpdated.imagemProfil;
      localStorage.setItem("user", JSON.stringify(userupdated));
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  const submitHandlerBiFile = async () => {
    const biUpdated = { userId: currentUser._id };

    if (fileBi) {
      const data = new FormData();
      const fileName = Date.now() + fileBi.name;
      data.append("file", fileBi);
      data.append("name", fileName);

      try {
        const res = await axios.post("usuarios/upload-bi", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        biUpdated.bi = res.data.bi;
      } catch (err) {
        console.log(err);
      }
    }

    try {
      await axios.put("usuarios/" + currentUser._id, biUpdated);
      setFile(null);
      userupdated.bi = biUpdated.bi;
      localStorage.setItem("user", JSON.stringify(userupdated));
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  const documentos_do_procurador = async () => {
    const biUpdated = { userId: currentUser._id };

    if (fileProcurador) {
      const data = new FormData();
      const fileName = Date.now() + fileProcurador.name;
      data.append("file", fileProcurador);
      data.append("name", fileName);

      try {
        const res = await axios.post("usuarios/upload-bi", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        biUpdated.documentos_do_procurador = res.data.bi;
      } catch (err) {
        console.log(err);
      }

      try {
        await axios.put("usuarios/" + currentUser._id, biUpdated);
        setFile(null);
        userupdated.documentos_do_procurador =
          biUpdated.documentos_do_procurador;
        localStorage.setItem("user", JSON.stringify(userupdated));
        window.location.reload();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const submit_diario_republica = async () => {
    const biUpdated = { userId: currentUser._id };

    if (diario_republica) {
      const data = new FormData();
      const fileName = Date.now() + diario_republica.name;
      data.append("file", diario_republica);
      data.append("name", fileName);

      try {
        const res = await axios.post("usuarios/upload-bi", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        biUpdated.diario_republica = res.data.bi;
      } catch (err) {
        console.log(err);
      }

      try {
        await axios.put("usuarios/" + currentUser._id, biUpdated);
        setFile(null);
        userupdated.diario_republica = biUpdated.diario_republica;
        localStorage.setItem("user", JSON.stringify(userupdated));
        window.location.reload();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const submit_registo_comercial = async () => {
    const biUpdated = { userId: currentUser._id };

    if (registo_comercial) {
      const data = new FormData();
      const fileName = Date.now() + registo_comercial.name;
      data.append("file", registo_comercial);
      data.append("name", fileName);

      try {
        const res = await axios.post("usuarios/upload-bi", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        biUpdated.registo_comercial = res.data.bi;
      } catch (err) {
        console.log(err);
      }

      try {
        await axios.put("usuarios/" + currentUser._id, biUpdated);
        setFile(null);
        userupdated.registo_comercial = biUpdated.registo_comercial;
        localStorage.setItem("user", JSON.stringify(userupdated));
        window.location.reload();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const submit_Contrato_Sociedade = async () => {
    const biUpdated = { userId: currentUser._id };

    if (Contrato_Sociedade) {
      const data = new FormData();
      const fileName = Date.now() + Contrato_Sociedade.name;
      data.append("file", Contrato_Sociedade);
      data.append("name", fileName);

      try {
        const res = await axios.post("usuarios/upload-bi", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        biUpdated.Contrato_Sociedade = res.data.bi;
      } catch (err) {
        console.log(err);
      }

      try {
        await axios.put("usuarios/" + currentUser._id, biUpdated);
        setFile(null);
        userupdated.Contrato_Sociedade = biUpdated.Contrato_Sociedade;
        localStorage.setItem("user", JSON.stringify(userupdated));
        window.location.reload();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const submit_nif = async () => {
    const biUpdated = { userId: currentUser._id };

    if (nif) {
      const data = new FormData();
      const fileName = Date.now() + nif.name;
      data.append("file", nif);
      data.append("name", fileName);

      try {
        const res = await axios.post("usuarios/upload-bi", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        biUpdated.nif = res.data.bi;
      } catch (err) {
        console.log(err);
      }

      try {
        await axios.put("usuarios/" + currentUser._id, biUpdated);
        setFile(null);
        userupdated.nif = biUpdated.nif;
        localStorage.setItem("user", JSON.stringify(userupdated));
        window.location.reload();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const followUser = async () => {
    setLoading(true);
    try {
      await axios.put("usuarios/" + user._id + "/seguir", {
        userId: currentUser._id,
      });
      setFollowinguser("followed");
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
    // try {
    //   await axios.post("conversations", {
    //     senderId: currentUser._id,
    //     receiverId: userId,
    //   });
    //   setFollowinguser("followed");
    //   window.location.reload();
    // } catch (err) {
    //   console.log(err);
    // }
  };

  const unfollowUser = () => {
    setLoading(true);
    try {
      setFollowinguser(false);
      axios.put("usuarios/" + user._id + "/naoseguir", {
        userId: currentUser._id,
      });
      setFollowinguser("removed");

      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const changeimg = () => {
      if (file) {
        setimgselected(URL.createObjectURL(file));
      }
    };
    changeimg();
  }, [file]);

  const verificarConta = async () => {
    var updateEstado = { userId: currentUser._id };
    if (!user.conta) {
      if (
        !userupdated.email ||
        !userupdated.Tel ||
        !userupdated.provincia ||
        !userupdated.municipio ||
        !userupdated.morada ||
        !userupdated.bi
        //       !fileProcurador ||
        // !diario_republica ||
        // !registo_comercial ||
        // !Contrato_Sociedade
      ) {
        setErroMessage("por favor preenche todos como com *");
        setTimeout(function () {
          setErroMessage(null);
        }, 4000);
      } else {
        updateEstado.conta = "48h de Verficação";
        try {
          await axios.put("usuarios/" + currentUser._id, updateEstado);
          userupdated.conta = updateEstado.conta;
          localStorage.setItem("user", JSON.stringify(userupdated));
          window.location.reload();
        } catch (err) {
          console.log(err);
        }
      }
    }
  };

  const verificarContaColectiva = async () => {
    var updateEstado = { userId: currentUser._id };
    if (!user.conta) {
      if (
        !userupdated.email ||
        !userupdated.Tel ||
        !userupdated.provincia ||
        !userupdated.municipio ||
        !userupdated.morada ||
        !userupdated.bi ||
        !fileProcurador ||
        !diario_republica ||
        !registo_comercial ||
        !Contrato_Sociedade
      ) {
        setErroMessage("por favor preenche todos como com *");
        setTimeout(function () {
          setErroMessage(null);
        }, 4000);
      } else {
        updateEstado.conta = "48h de Verficação";
        try {
          await axios.put("usuarios/" + currentUser._id, updateEstado);
          userupdated.conta = updateEstado.conta;
          localStorage.setItem("user", JSON.stringify(userupdated));
          window.location.reload();
        } catch (err) {
          console.log(err);
        }
      }
    }
  };

  const currentusername = useRef();
  const Tel = useRef();
  const desc = useRef();
  const email = useRef();
  const password = useRef();
  const provincia = useRef();
  const municipio = useRef();
  const morada = useRef();
  const facebook = useRef();
  const google = useRef();
  const instagram = useRef();
  const linkedin = useRef();

  const updateUser = async (e) => {
    setLoading(true);
    e.preventDefault();
    const userupdated = {
      userId: currentUser._id,
      username: currentusername.current.value
        ? currentusername.current.value
        : currentUser.username,
      Tel: Tel.current.value ? Tel.current.value : currentUser.Tel,
      desc: desc.current.value ? desc.current.value : currentUser.desc,
      email: email.current.value ? email.current.value : currentUser.email,
      provincia: provincia.current.value
        ? provincia.current.value
        : currentUser.provincia,
      email: email.current.value ? email.current.value : currentUser.email,
      municipio: municipio.current.value
        ? municipio.current.value
        : currentUser.municipio,
      morada: morada.current.value ? morada.current.value : currentUser.morada,

      facebook: facebook.current.value
        ? facebook.current.value
        : currentUser.facebook,
      google: google.current.value ? google.current.value : currentUser.google,
      instagram: instagram.current.value
        ? instagram.current.value
        : currentUser.instagram,
      linkedin: linkedin.current.value
        ? linkedin.current.value
        : currentUser.linkedin,
    };

    try {
      await axios.put("usuarios/" + currentUser._id, userupdated);
      setupdUser(userupdated);
      // localStorage.setItem("user", JSON.stringify(userupdated));

      setLoading(false);
      setOpenSuccess(true);
    } catch (err) {
      console.log(err);
    }
  };

  const updateSenha = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (password.current.value) {
      try {
        await axios.put("usuarios/" + currentUser._id, {
          password: password.current.value,
          userId: currentUser._id,
        });
        setupdUser({ updated: "yes" });
        setLoading(false);
        setOpenSuccess(true);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSuccess(false);
  };

  return (
    <>
      <Snackbar
        open={openSuccess}
        autoHideDuration={2300}
        onClose={handleCloseSuccess}
      >
        <Alert onClose={handleCloseSuccess} severity={dialogMessage.style}>
          {dialogMessage.message}
        </Alert>
      </Snackbar>
      <div className="row">
        <div className="col-xl-4 col-lg-5 scrollP">
          <div className="card-header text-center bg-warning">
            <span style={{ color: "black", fontWeight: "bold" }}>
              Conta {user.categoria}
            </span>
          </div>
          <div className="card text-center">
            <div className="card-body">
              {file ? (
                <>
                  {" "}
                  <img
                    src={imgselected}
                    className="rounded-circle avatar-lg img-thumbnail"
                    alt="profile-image"
                  />
                  <i
                    className="text-success bi bi-check-circle-fill"
                    onClick={() => submitHandler()}
                  ></i>
                  <i
                    className="text-danger bi bi-x-circle-fill"
                    onClick={() => setFile(null)}
                  ></i>{" "}
                </>
              ) : (
                <>
                  {" "}
                  <img
                    src={
                      user.imagemProfil
                        ? PS + "users/" + user.imagemProfil
                        : PS + "users/noavatar.jpg"
                    }
                    className="rounded-circle avatar-lg img-thumbnail"
                    alt="profile-image"
                  />
                  <label htmlFor="file">
                    <a>
                      {" "}
                      <i className="bi bi-camera-fill"></i>
                    </a>
                    <input
                      type="file"
                      id="file"
                      accept=".png,.jpeg,.jpg"
                      onChange={(e) => setFile(e.target.files[0])}
                      style={{ display: "none" }}
                    />
                  </label>
                </>
              )}

              <h4 className="mb-0 mt-2 username">{user.username}</h4>
              <p className="text-muted font-14">{user.categoria}</p>
              <div>
                {loading ? (
                  <CircularProgress color="green" size="22px" />
                ) : user._id != currentUser._id ? (
                  friendList ? (
                    <Tooltip title="Parar de seguir">
                      <IconButton onClick={unfollowUser}>
                        <PersonAddDisabledIcon />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Seguir">
                      <IconButton onClick={followUser}>
                        <PersonAddIcon />
                      </IconButton>
                    </Tooltip>
                  )
                ) : (
                  ""
                )}
              </div>

              <div className="text-start mt-3" style={{ color: "white" }}>
                <h4 className="font-13 text-uppercase">Sobre mim :</h4>
                <p className=" font-13 mb-3">{user.desc}</p>
                <p className=" mb-2 font-13">
                  <strong>Nome Completo :</strong>{" "}
                  <span className="ms-2">{user.username}</span>
                </p>

                <p className=" mb-2 font-13">
                  <strong>Telefone :</strong>
                  <span className="ms-2">{user.Tel}</span>
                </p>

                <p className=" mb-2 font-13">
                  <strong>Email :</strong>{" "}
                  <span className="ms-2 ">{user.email}</span>
                </p>

                <p className=" mb-1 font-13">
                  <strong>Localidade :</strong>{" "}
                  <span className="ms-2">{user.morada}</span>
                </p>
              </div>

              <ul className="social-list list-inline mt-3 mb-0">
                <li className="list-inline-item">
                  <a
                    href={user.facebook}
                    target="_blank"
                    className="social-list-item border-primary text-primary"
                    style={{ backgroundColor: "white" }}
                  >
                    <i className="mdi mdi-facebook"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href={user.google}
                    target="_blank"
                    className="social-list-item border-danger text-danger"
                    style={{ backgroundColor: "white" }}
                  >
                    <i className="mdi mdi-google"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href={user.linkedin}
                    target="_blank"
                    className="social-list-item border-info text-info"
                    style={{ backgroundColor: "white" }}
                  >
                    <i className="mdi mdi-linkedin"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href={user.instagram}
                    target="_blank"
                    className="social-list-item border-primary"
                    style={{ backgroundColor: "white", color: "purple" }}
                  >
                    <i className="mdi mdi-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="card ribbon-box">
            <div className="card-body">
              <div className="ribbon ribbon-warning float-end">
                <i class="bi bi-brightness-alt-low-fill"></i>
                {user.categoria}
              </div>
              <h5 className="text-dark float-start mt-0">Estado da Conta</h5>
              <div className="ribbon-content">
                <div>
                  {" "}
                  <span style={{ fontWeight: "bold", color: "white" }}>
                    Conta:
                  </span>{" "}
                  pendente <i className="bi bi-lightbulb text-warning"></i>
                </div>
                <span style={{ fontWeight: "bold", color: "white" }}>
                  Valor liquido:
                </span>{" "}
                {user.valorLiquido} kz
              </div>
              <span className="text-success" style={{ fontWeight: "bold" }}>
                Carteira:
              </span>{" "}
              {user.carteira} kz
              <div style={{ marginTop: "5px" }}></div>
            </div>

            {user.conta ? (
              <div className="card-footer text-center nova-conta bg-success">
                {user.conta}
              </div>
            ) : user.tipo == "Colectivo" ? (
              <>
                <div
                  className="card-footer text-center nova-conta bg-success"
                  onClick={() => verificarContaColectiva()}
                >
                  OBTER CONTA NORMAL
                </div>
              </>
            ) : (
              <>
                <div
                  className="card-footer text-center nova-conta bg-success"
                  onClick={() => verificarConta()}
                >
                  OBTER CONTA NORMAL
                </div>
              </>
            )}

            <div className="text-center text-warning">
              <strong> {ErroMessage} </strong>
            </div>
          </div>
        </div>

        <div className="col-xl-8 col-lg-7 scrollprofile">
          <div className="card">
            <div className="card-body">
              <ul className="nav nav-pills bg-nav-pills nav-justified mb-3">
                {/* <li className="nav-item">
                    <a
                      href="#aboutme"
                      data-bs-toggle="tab"
                      aria-expanded="false"
                      className="nav-link rounded-0"
                    >
                      Resume
                    </a>
                  </li> */}
                <li className="nav-item">
                  <a
                    href="#timeline"
                    data-bs-toggle="tab"
                    aria-expanded="true"
                    className="nav-link rounded-0"
                  >
                    Cronologia
                  </a>
                </li>

                {user._id != currentUser._id ? (
                  " "
                ) : (
                  <li className="nav-item">
                    <a
                      href="#settings"
                      data-bs-toggle="tab"
                      aria-expanded="false"
                      className="nav-link rounded-0 active"
                    >
                      Editar Portfólio
                    </a>
                  </li>
                )}
              </ul>
              <div className="tab-content">
                <div className="tab-pane" id="aboutme">
                  <h5 className="text-uppercase">
                    <i className="mdi mdi-briefcase me-1"></i>
                    Experiência
                  </h5>

                  <div className="timeline-alt pb-0">
                    <div className="timeline-item">
                      <i className="mdi mdi-circle bg-info-lighten text-info timeline-icon"></i>
                      <div className="timeline-item-info">
                        <h5 className="mt-0 mb-1">
                          Designer / desenvolvedor líder
                        </h5>
                        <p className="font-14">
                          websitename.com{" "}
                          <span className="ms-2 font-12">Ano: 2015 - 18</span>
                        </p>
                        <p className="text-muted mt-2 mb-0 pb-3">
                          Everyone realizes why a new common language seria
                          desejável: alguém poderia se recusar a pagar
                          tradutores caros. Para conseguir isso, seria
                          necessário ter uma gramática uniforme, pronúncia e
                          palavras mais comuns.
                        </p>
                      </div>
                    </div>

                    <div className="timeline-item">
                      <i className="mdi mdi-circle bg-primary-lighten text-primary timeline-icon"></i>
                      <div className="timeline-item-info">
                        <h5 className="mt-0 mb-1">Designer Gráfico Sênior</h5>
                        <p className="font-14">
                          Software Inc.{" "}
                          <span className="ms-2 font-12">ano: 2012 - 15</span>
                        </p>
                        <p className="text-muted mt-2 mb-0 pb-3">
                          Se várias línguas se aglutinam, a gramática da
                          linguagem resultante é mais simples e regular do que a
                          de as línguas individuais. A nova linguagem comum será
                          mais simples e regulares do que as línguas europeias
                          existentes.
                        </p>
                      </div>
                    </div>

                    <div className="timeline-item">
                      <i className="mdi mdi-circle bg-info-lighten text-info timeline-icon"></i>
                      <div className="timeline-item-info">
                        <h5 className="mt-0 mb-1">Designer gráfico</h5>
                        <p className="font-14">
                          Coderthemes Design LLP{" "}
                          <span className="ms-2 font-12">ano: 2010 - 12</span>
                        </p>
                        <p className="text-muted mt-2 mb-0 pb-2">
                          The European languages are members of a mesma família.
                          Sua existência separada é um mito. Pela ciência
                          música, esporte, etc., a Europa usa o mesmo
                          vocabulário. As línguas só diferem na gramática e na
                          pronúncia.
                        </p>
                      </div>
                    </div>
                  </div>

                  <h5 className="mb-3 mt-4 text-uppercase">
                    <i className="mdi mdi-cards-variant me-1"></i>
                    Grupos Criado
                  </h5>
                  <ul className="list-group">
                    <a href="#">
                      <li className="list-group-item d-flex justify-content-between align-items-center">
                        Futuro de BTC
                        <span className="badge bg-primary rounded-pill">
                          14
                        </span>
                      </li>
                    </a>
                  </ul>
                </div>

                <div className="tab-pane show scroll" id="timeline">
                  <Feed username={user.username} />

                  <div className="text-center">
                    <a href="javascript:void(0);" className="text-danger">
                      <i className="mdi mdi-spin mdi-loading me-1"></i> Load
                      more{" "}
                    </a>
                  </div>
                </div>

                <div className="tab-pane active" id="settings">
                  <form>
                    <h5 className="mb-4 text-uppercase">
                      <i className="mdi mdi-account-circle me-1"></i>Dados
                      pessoais
                    </h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label for="firstname" className="form-label">
                            Nome Completo <span className="text-danger">*</span>
                          </label>
                          <input
                            placeholder={user.username}
                            type="text"
                            className="form-control"
                            id="firstname"
                            placeholder="Digite seu nome"
                            ref={currentusername}
                            defaultValue={user.username}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label for="firstname" className="form-label">
                            Nº Telefone <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Digite seu Nº telemovel"
                            ref={Tel}
                            defaultValue={user.Tel}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="mb-3">
                          <label for="userbio" className="form-label">
                            Sobre mim
                          </label>
                          <textarea
                            className="form-control"
                            id="userbio"
                            rows="4"
                            placeholder="Escreve alo sobre te.."
                            ref={desc}
                            defaultValue={user.desc}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label for="useremail" className="form-label">
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="useremail"
                            placeholder="Digite o seu email"
                            ref={email}
                            defaultValue={user.email}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="localidade" className="form-label">
                            Província <span className="text-danger">*</span>
                          </label>
                          <select
                            name="localidade"
                            className="form-control"
                            id=""
                            ref={provincia}
                            defaultValue={user.provincia}
                          >
                            <option value="Luanda">Luanda</option>
                            <option value="Bengo">Bengo</option>
                            <option value="Benguela">Benguela</option>
                            <option value="Bié">Bié</option>
                            <option value="Cabinda">Cabinda</option>
                            <option value="Cunene">Cunene</option>
                            <option value="Huambo">Huambo</option>
                            <option value="Huíla">Huíla</option>
                            <option value="Kuando Kubango">
                              Kuando Kubango
                            </option>
                            <option value="Kwanza Norte">Kwanza Norte</option>
                            <option value="Kwanza Sul">Kwanza Sul</option>
                            <option value="Lunda Norte">Lunda Norte</option>
                            <option value="Lunda Sul">Lunda Sul</option>
                            <option value="Malange">Malange</option>
                            <option value="Moxico">Moxico</option>
                            <option value="Namibe">Namibe</option>
                            <option value="Uíge">Uíge</option>
                            <option value="Zaire">Zaire</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3 ">
                          <label for="municioio" className="form-label">
                            Município <span className="text-danger">*</span>
                          </label>
                          <select
                            name="municipio"
                            className="form-control select2"
                            data-toggle="select2"
                            ref={municipio}
                            defaultValue={user.municipio}
                          >
                            <option>Seleciona municioio</option>
                            <optgroup label="Luanda">
                              <option value="Luanda">Luanda</option>
                              <option value="Belas">Belas</option>
                              <option value="Cacuaco">Cacuaco</option>
                              <option value="Cazenga">Cazenga</option>
                              <option value="Icolo e Bengo">
                                Icolo e Bengo
                              </option>
                              <option value="Quiçama">Quiçama</option>
                              <option value="Kilamba">Kilamba Kiaxi</option>
                              <option value="Talatona">Talatona</option>
                              <option value="Viana">Viana</option>
                            </optgroup>
                            <optgroup label="Bengo">
                              <option value="Ambriz">Ambriz</option>
                              <option value="Dande">Dande</option>
                              <option value="Dembos">Dembos</option>
                              <option value="Bula Atumba">Bula Atumba</option>
                              <option value="Nambuangongo">Nambuangongo</option>
                              <option value="Pango Aluquêm">
                                Pango Aluquêm
                              </option>
                            </optgroup>

                            <optgroup label="Benguela">
                              <option value="Benguela">Benguela</option>
                              <option value="Balombo">Balombo</option>
                              <option value="Baía Farta">Baía Farta</option>
                              <option value="Bocoio">Bocoio</option>
                              <option value="Caimbambo">Caimbambo</option>
                              <option value="Catumbela">Catumbela</option>
                              <option value="Chongoroi">Chongoroi</option>
                              <option value="Cubal">Cubal</option>
                              <option value="Bocoio">Bocoio</option>
                              <option value="Ganda">Ganda</option>
                              <option value="Lobito">Lobito</option>
                            </optgroup>

                            <optgroup label="Bié">
                              <option value="Andulo">Andulo</option>
                              <option value="Camacupa">Camacupa</option>
                              <option value="Catabola">Catabola</option>
                              <option value="Chinguar">Chinguar</option>
                              <option value="Chitembo">Chitembo</option>
                              <option value="Cuemba">Cuemba</option>
                              <option value="Cunhinga">Cunhinga</option>
                              <option value="Kuito">Kuito</option>
                              <option value="Nharea">Nharea</option>
                            </optgroup>

                            <optgroup label="Cabinda">
                              <option vlaue="Belize">Belize</option>
                              <option vlaue="Buco-Zau">Buco-Zau</option>
                              <option vlaue="Cabinda">Cabinda</option>
                              <option vlaue="Cacongo">Cacongo</option>
                            </optgroup>

                            <optgroup label="Cunene">
                              <option value="Cahama">Cahama</option>
                              <option value="Cuanhama">Cuanhama</option>
                              <option value="Curoca">Curoca</option>
                              <option value="Cuvelay">Cuvelay</option>
                              <option value="Namacunde">Namacunde</option>
                              <option value="Ombadja">Ombadja</option>
                            </optgroup>

                            <optgroup label="Cunene">
                              <option value="Bailundo">Bailundo</option>
                              <option value="Catchiungo">Catchiungo</option>
                              <option value="Caála">Caála</option>
                              <option value="Ekunha">Ekunha</option>
                              <option value="Huambo">Huambo</option>
                              <option value="Londuimbale">Londuimbale</option>
                              <option value="Longongo">Longongo</option>
                              <option value="Mungo">Mungo</option>
                              <option value="Tchicala-Tcholoanga">
                                Tchicala-Tcholoanga
                              </option>
                              <option value="Tchindjenje">Tchindjenje</option>
                              <option value="Ucuma">Ucuma</option>
                            </optgroup>

                            <optgroup label="Huíla">
                              <option>Caconda</option>
                              <option>Cacula</option>
                              <option>Caluquembe</option>
                              <option>Chiange</option>
                              <option>Chibia</option>
                              <option>Chicomba</option>
                              <option>Chipindo</option>
                              <option>Humpata</option>
                              <option>Jamba</option>
                              <option>Kuvango</option>
                              <option>Lubango</option>
                              <option>Matala</option>
                              <option>Quilengues</option>
                              <option>Quipungo</option>
                            </optgroup>

                            <optgroup label="Kuando Kubango">
                              <option>Calai</option>
                              <option>Cuangar</option>
                              <option>Cuchi</option>
                              <option>Cuito Cuanavale</option>
                              <option>Dirico</option>
                              <option>Longa</option>
                              <option>Mavinga</option>
                              <option>Menongue</option>
                              <option>Rivungo</option>
                            </optgroup>

                            <optgroup label="Kwanza Norte">
                              <option>Ambaca</option>
                              <option>Banga</option>
                              <option>Bolongongo</option>
                              <option>Cambambe</option>
                              <option>Cazengo</option>
                              <option>Golungo Alto</option>
                              <option>Gonguembo</option>
                              <option>Lucala</option>
                              <option>Quiculungo</option>
                              <option>Samba Caju</option>
                            </optgroup>

                            <optgroup label="Kwanza Sul">
                              <option>Amboim</option>
                              <option>Cassongue</option>
                              <option>Conda</option>
                              <option>Ebo</option>
                              <option>Libolo</option>
                              <option>Mussende</option>
                              <option>Porto Amboim</option>
                              <option>Quibala</option>
                              <option>Quilenda</option>
                              <option>Seles</option>
                              <option>Sumbe</option>
                              <option>Waku Kungo</option>
                            </optgroup>

                            <optgroup label="Lunda Norte">
                              <option>Cambulo</option>
                              <option>Capenda-Camulemba</option>
                              <option>Caungula</option>
                              <option>Chitato (Tchitato)</option>
                              <option>Cuango</option>
                              <option>Cuilo</option>
                              <option>Lóvua</option>
                              <option>Lubalo</option>
                              <option>Lucapa</option>
                              <option>Xá Muteba</option>
                            </optgroup>

                            <optgroup label="Lunda Sul">
                              <option>Cacolo</option>
                              <option>Dala</option>
                              <option>Muconda</option>
                              <option>Saurimo</option>
                            </optgroup>

                            <optgroup label="Malange">
                              <option>Cacuso</option>
                              <option>Calandula</option>
                              <option>Cambundi-Catembo</option>
                              <option>Cangandala</option>
                              <option>Caombo</option>
                              <option>Cuaba Nzogo</option>
                              <option>Cunda-Diaza</option>
                              <option>Luquembo</option>
                              <option>Malange</option>
                              <option>Marimba</option>
                              <option>Massango</option>
                              <option>Caculama-Mucari</option>
                              <option>Quela</option>
                              <option>Quirima</option>
                            </optgroup>

                            <optgroup label="Moxico">
                              <option>Alto Zambeze</option>
                              <option>Capenda-Camulemba</option>
                              <option>Bundas</option>
                              <option>Camanongue</option>
                              <option>Cameia</option>
                              <option>Luau</option>
                              <option>Lucano</option>
                              <option>Luchazes</option>
                              <option>Léua</option>
                              <option>Moxico</option>
                            </optgroup>

                            <optgroup label="Namibe">
                              <option>Bibala</option>
                              <option>Camulo</option>
                              <option>Namibe</option>
                              <option>Tômbua</option>
                              <option>Virei</option>
                            </optgroup>

                            <optgroup label="Uíge">
                              <option>Alto Cauale</option>
                              <option>Ambuíla</option>
                              <option>Bembe</option>
                              <option>Buengas</option>
                              <option>Bungo</option>
                              <option>Damba</option>
                              <option>Macocola</option>
                              <option>Mucaba</option>
                              <option>Negage</option>
                              <option>Puri</option>
                              <option>Quimbele</option>
                              <option>Quitexe</option>
                              <option>Sanza Pombo</option>
                              <option>Songo</option>
                              <option>Uíge</option>
                              <option>Maquela do Zombo</option>
                            </optgroup>

                            <optgroup label="Zaire">
                              <option>Cuimba</option>
                              <option>M'Banza Kongo</option>
                              <option>Noqui</option>
                              <option>N'Zeto</option>
                              <option>Soyo</option>
                              <option>Tomboco</option>
                            </optgroup>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <label for="morada" className="form-label">
                            Morada <span className="text-danger">*</span>
                          </label>
                          <textarea
                            name="morada"
                            className="form-control"
                            placeholder="Digite a sua morada"
                            ref={morada}
                            defaultValue={user.morada}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <h5 className="mb-3 text-uppercase bg-light p-2">
                      <i className="bi bi-file-earmark-text "></i> Documento(s)
                    </h5>
                    <div className="row">
                      <div className="col-md-3">
                        <label htmlFor="filebi">
                          <div className="card m-1 shadow-none border campo-bi">
                            <div className="p-2">
                              <div className="row align-items-center">
                                <div className="col-auto">
                                  <div className="avatar-sm">
                                    <span className="avatar-title bg-light text-secondary rounded">
                                      <i className="mdi mdi-file-pdf-outline font-18"></i>
                                    </span>
                                  </div>
                                </div>
                                <div className="col ps-0">
                                  <a
                                    href="javascript:void(0);"
                                    className="text-muted fw-bold"
                                  ></a>

                                  <a>
                                    {" "}
                                    <span className="text-danger">*</span>
                                    BI
                                    <p className="mb-0 font-13">
                                      {fileBi ? fileBi.name : <> {user.bi}</>}
                                    </p>
                                    <p class="mb-0 font-13">
                                      {" "}
                                      {fileBi ? fileBi.size / 1000 + "KB" : ""}
                                    </p>
                                  </a>
                                  <input
                                    type="file"
                                    id="filebi"
                                    accept=".png,.jpeg,.jpg,"
                                    onChange={(e) =>
                                      setFileBi(e.target.files[0])
                                    }
                                    style={{ display: "none" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                        <div>
                          {fileBi ? (
                            <>
                              {" "}
                              <i
                                className="text-success bi bi-check-circle bifile"
                                style={{
                                  marginTop: "-90px",
                                  marginLeft: "175px",
                                }}
                                onClick={() => submitHandlerBiFile()}
                              ></i>
                              <i
                                className="text-danger bi bi-x-circle bifile"
                                style={{
                                  marginTop: "-50px",
                                  marginLeft: "175px",
                                }}
                                onClick={() => setFileBi(null)}
                              ></i>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      {user.tipo == "Colectivo" ? (
                        <>
                          {" "}
                          <div className="col-md-6">
                            <label htmlFor="fileProcurador">
                              <div className="card m-1 shadow-none border campo-bi">
                                <div className="p-2">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <div className="avatar-sm">
                                        <span className="avatar-title bg-light text-secondary rounded">
                                          <i className="mdi mdi-file-pdf-outline font-18"></i>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col ps-0">
                                      <a
                                        href="javascript:void(0);"
                                        className="text-muted fw-bold"
                                      ></a>

                                      <a>
                                        {" "}
                                        <span className="text-danger">
                                          *
                                        </span>{" "}
                                        Eventuais Procurações e os documentos do
                                        procurador
                                        <p className="mb-0 font-13">
                                          {fileProcurador ? (
                                            fileProcurador.name
                                          ) : (
                                            <>
                                              {" "}
                                              {user.documentos_do_procurador}
                                            </>
                                          )}
                                        </p>
                                        <p class="mb-0 font-13">
                                          {" "}
                                          {fileProcurador
                                            ? fileProcurador.size / 1000 + "KB"
                                            : ""}
                                        </p>
                                      </a>
                                      <input
                                        type="file"
                                        id="fileProcurador"
                                        accept=".png,.jpeg,.jpg,"
                                        onChange={(e) =>
                                          setfileProcurador(e.target.files[0])
                                        }
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </label>
                            <div>
                              {fileProcurador ? (
                                <>
                                  {" "}
                                  <i
                                    className="text-success bi bi-check-circle bifile"
                                    style={{
                                      marginTop: "-90px",
                                      marginLeft: "350px",
                                    }}
                                    onClick={() => documentos_do_procurador()}
                                  ></i>
                                  <i
                                    className="text-danger bi bi-x-circle bifile"
                                    style={{
                                      marginTop: "-50px",
                                      marginLeft: "350px",
                                    }}
                                    onClick={() => setfileProcurador(null)}
                                  ></i>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="diario_republica">
                              <div className="card m-1 shadow-none border campo-bi">
                                <div className="p-2">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <div className="avatar-sm">
                                        <span className="avatar-title bg-light text-secondary rounded">
                                          <i className="mdi mdi-file-pdf-outline font-18"></i>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col ps-0">
                                      <a
                                        href="javascript:void(0);"
                                        className="text-muted fw-bold"
                                      ></a>

                                      <a>
                                        {" "}
                                        <span className="text-danger">*</span>
                                        Diário da República
                                        <p className="mb-0 font-13">
                                          {diario_republica ? (
                                            diario_republica.name
                                          ) : (
                                            <> {user.diario_republica}</>
                                          )}
                                        </p>
                                        <p class="mb-0 font-13">
                                          {" "}
                                          {diario_republica
                                            ? diario_republica.size / 1000 +
                                              "KB"
                                            : ""}
                                        </p>
                                      </a>
                                      <input
                                        type="file"
                                        id="diario_republica"
                                        accept=".png,.jpeg,.jpg,"
                                        onChange={(e) =>
                                          setdiario_republica(e.target.files[0])
                                        }
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </label>
                            <div>
                              {diario_republica ? (
                                <>
                                  {" "}
                                  <i
                                    className="text-success bi bi-check-circle bifile"
                                    style={{
                                      marginTop: "-90px",
                                      marginLeft: "160px",
                                    }}
                                    onClick={() => submit_diario_republica()}
                                  ></i>
                                  <i
                                    className="text-danger bi bi-x-circle bifile"
                                    style={{
                                      marginTop: "-50px",
                                      marginLeft: "160px",
                                    }}
                                    onClick={() => setdiario_republica(null)}
                                  ></i>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="registo_comercial">
                              <div className="card m-1 shadow-none border campo-bi">
                                <div className="p-2">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <div className="avatar-sm">
                                        <span className="avatar-title bg-light text-secondary rounded">
                                          <i className="mdi mdi-file-pdf-outline font-18"></i>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col ps-0">
                                      <a
                                        href="javascript:void(0);"
                                        className="text-muted fw-bold"
                                      ></a>

                                      <a>
                                        {" "}
                                        <span className="text-danger">*</span>
                                        Certidão do Registo Comercial
                                        <p className="mb-0 font-13">
                                          {registo_comercial ? (
                                            registo_comercial.name
                                          ) : (
                                            <> {user.registo_comercial}</>
                                          )}
                                        </p>
                                        <p class="mb-0 font-13">
                                          {" "}
                                          {registo_comercial
                                            ? registo_comercial.size / 1000 +
                                              "KB"
                                            : ""}
                                        </p>
                                      </a>
                                      <input
                                        type="file"
                                        id="registo_comercial"
                                        accept=".png,.jpeg,.jpg,"
                                        onChange={(e) =>
                                          setregisto_comercial(
                                            e.target.files[0]
                                          )
                                        }
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </label>
                            <div>
                              {registo_comercial ? (
                                <>
                                  {" "}
                                  <i
                                    className="text-success bi bi-check-circle bifile"
                                    style={{
                                      marginTop: "-90px",
                                      marginLeft: "300px",
                                    }}
                                    onClick={() => submit_registo_comercial()}
                                  ></i>
                                  <i
                                    className="text-danger bi bi-x-circle bifile"
                                    style={{
                                      marginTop: "-50px",
                                      marginLeft: "300px",
                                    }}
                                    onClick={() => setregisto_comercial(null)}
                                  ></i>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="Contrato_Sociedade">
                              <div className="card m-1 shadow-none border campo-bi">
                                <div className="p-2">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <div className="avatar-sm">
                                        <span className="avatar-title bg-light text-secondary rounded">
                                          <i className="mdi mdi-file-pdf-outline font-18"></i>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col ps-0">
                                      <a
                                        href="javascript:void(0);"
                                        className="text-muted fw-bold"
                                      ></a>

                                      <a>
                                        {" "}
                                        <span className="text-danger">*</span>
                                        Escritura Pública ou Contrato de
                                        Sociedade
                                        <p className="mb-0 font-13">
                                          {Contrato_Sociedade ? (
                                            Contrato_Sociedade.name
                                          ) : (
                                            <> {user.Contrato_Sociedade}</>
                                          )}
                                        </p>
                                        <p class="mb-0 font-13">
                                          {" "}
                                          {Contrato_Sociedade
                                            ? Contrato_Sociedade.size / 1000 +
                                              "KB"
                                            : ""}
                                        </p>
                                      </a>
                                      <input
                                        type="file"
                                        id="Contrato_Sociedade"
                                        accept=".png,.jpeg,.jpg,"
                                        onChange={(e) =>
                                          setContrato_Sociedade(
                                            e.target.files[0]
                                          )
                                        }
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </label>
                            <div>
                              {Contrato_Sociedade ? (
                                <>
                                  {" "}
                                  <i
                                    className="text-success bi bi-check-circle bifile"
                                    style={{
                                      marginTop: "-90px",
                                      marginLeft: "350px",
                                    }}
                                    onClick={() => submit_Contrato_Sociedade()}
                                  ></i>
                                  <i
                                    className="text-danger bi bi-x-circle bifile"
                                    style={{
                                      marginTop: "-50px",
                                      marginLeft: "350px",
                                    }}
                                    onClick={() => setContrato_Sociedade(null)}
                                  ></i>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="nif">
                              <div className="card m-1 shadow-none border campo-bi">
                                <div className="p-2">
                                  <div className="row align-items-center">
                                    <div className="col-auto">
                                      <div className="avatar-sm">
                                        <span className="avatar-title bg-light text-secondary rounded">
                                          <i className="mdi mdi-file-pdf-outline font-18"></i>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col ps-0">
                                      <a
                                        href="javascript:void(0);"
                                        className="text-muted fw-bold"
                                      ></a>

                                      <a>
                                        {" "}
                                        <span className="text-danger">*</span>
                                        NIF
                                        <p className="mb-0 font-13">
                                          {nif ? nif.name : <> {user.nif}</>}
                                        </p>
                                        <p class="mb-0 font-13">
                                          {" "}
                                          {nif ? nif.size / 1000 + "KB" : ""}
                                        </p>
                                      </a>
                                      <input
                                        type="file"
                                        id="nif"
                                        accept=".png,.jpeg,.jpg,"
                                        onChange={(e) =>
                                          setnif(e.target.files[0])
                                        }
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </label>
                            <div>
                              {nif ? (
                                <>
                                  {" "}
                                  <i
                                    className="text-success bi bi-check-circle bifile"
                                    style={{
                                      marginTop: "-80px",
                                      marginLeft: "220px",
                                    }}
                                    onClick={() => submit_nif()}
                                  ></i>
                                  <i
                                    className="text-danger bi bi-x-circle bifile"
                                    style={{
                                      marginTop: "-40px",
                                      marginLeft: "220px",
                                    }}
                                    onClick={() => setnif(null)}
                                  ></i>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    <h5 className="mb-3 text-uppercase bg-light p-2">
                      <i className="mdi mdi-earth me-1"></i> Social
                    </h5>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="social-fb" className="form-label">
                            Facebook
                          </label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <i className="mdi mdi-facebook"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              id="social-fb"
                              placeholder="Url"
                              ref={facebook}
                              defaultValue={user.facebook}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="social-tw" className="form-label">
                            Google
                          </label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <i className="mdi mdi-google"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              id="social-tw"
                              placeholder="Username"
                              ref={google}
                              defaultValue={user.google}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="social-insta" className="form-label">
                            Instagram
                          </label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <i className="mdi mdi-instagram"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              id="social-insta"
                              placeholder="Url"
                              ref={instagram}
                              defaultValue={user.instagram}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label for="social-lin" className="form-label">
                            Linkedin
                          </label>
                          <div className="input-group">
                            <span className="input-group-text">
                              <i className="mdi mdi-linkedin"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              id="social-lin"
                              placeholder="Url"
                              ref={linkedin}
                              defaultValue={user.linkedin}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-outline-success btn-rounded mt-2"
                          onClick={updateUser}
                          disabled={loading}
                        >
                          {loading ? (
                            <CircularProgress color="green" size="22px" />
                          ) : (
                            "Atualizar"
                          )}
                        </button>
                      </div>
                    </div>

                    <h5 className="mb-3 mt-3 text-uppercase bg-light p-2">
                      <i className="mdi mdi-lock me-1"></i> Alterar Senha
                    </h5>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="">
                          <label for="userpassword" className="form-label">
                            Senha
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="userpassword"
                            placeholder="Digite a sua senha"
                            ref={password}
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="mb-3">
                          <button
                            type="submit"
                            className="btn btn-outline-info btn-rounded mt-2"
                            onClick={updateSenha}
                            disabled={loading}
                          >
                            {" "}
                            {loading ? (
                              <CircularProgress color="green" size="22px" />
                            ) : (
                              "redefinir"
                            )}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
